// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"de384c9ae66bfd59","9651":"fc15e5626dd62573"}[chunkId] + ".js";
};